// ENTITY fr.gestionpial.pial.dto.DashboardEcoleDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class DashboardEcoleDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.DashboardEcoleDTO';

  idEcole: number | null = 0;
  nom: string | null = '';
  besoinNotifMinutes: number | null = 0;
  affecteNotifMinutes: number | null = 0;
  affecteAbsentMinutes: number | null = 0;
  reserveMinutes: number | null = 0;

  constructor(init?:Partial<DashboardEcoleDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.DashboardEcoleDTO'] = DashboardEcoleDTO;

fields['fr.gestionpial.pial.dto.DashboardEcoleDTO']  = {
    idEcole: 'java.lang.Integer',
    nom: 'java.lang.String',
    besoinNotifMinutes: 'java.lang.Integer',
    affecteNotifMinutes: 'java.lang.Integer',
    affecteAbsentMinutes: 'java.lang.Integer',
    reserveMinutes: 'java.lang.Integer'
};
